import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';

class InvoiceP24ReturnContainer extends BaseContainer {
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'invoice-download-container';
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div id='main-invoice-download'>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                    <div className='invoice-download-background-container'>
                        <img src='/images/login-moya-background.svg' className='login-background-moya' alt='logo moya' />
                        <div className='login-moya-logo-container'>
                            <img src='/images/login-moya-logo.svg' className='login-moya-logo' alt='logo moya' />
                        </div>
                        <div className='invoice-download-text-container'>
                            <span className='invoice-download-welcome-text'>{t('invoiceP24Return.welcomeText')}</span>
                        </div>
                        <div className='invoice-download-guide-text-container'>
                            <div className='invoice-download-guide-text'>{t('invoiceP24Return.guideText')}</div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

InvoiceP24ReturnContainer.propTypes = {};

export default withTranslation()(InvoiceP24ReturnContainer);
